const initialState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
  error: null,
  userData: null,
  scheduleNotificationSuccess: false,
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_NOTIFICATIONS_REQUEST":
      return { ...state, loading: true, error: null };
    case "FETCH_NOTIFICATIONS_SUCCESS":
      return {
        ...state,
        loading: false,
        unreadCount: action.payload.total || 0,
      };
    case "FETCH_NOTIFICATIONS_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "MARK_NOTIFICATIONS_READ_SUCCESS":
      return { ...state, unreadCount: 0 };
    case "MARK_NOTIFICATIONS_READ_FAIL":
      return { ...state, error: "Failed to mark read" };
    case "UPDATE_UNREAD_COUNT":
      return { ...state, unreadCount: action.payload };
    case "GET_USER_REQUEST":
      return { ...state, loading: true, error: null };

    case "GET_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        userData: action.payload,
        error: null,
      };

    case "GET_USER_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
        userData: null,
      };

    case "SCHEDULE_NOTIFICATION_REQUEST":
      return { ...state, loading: true, error: null, scheduleNotificationSuccess: false };
    case "SCHEDULE_NOTIFICATION_SEND_SUCCESS":
      return { ...state, loading: false, scheduleNotificationSuccess: true, error: null };
    case "SCHEDULE_NOTIFICATION_SEND_FAILURE":
      return { ...state, loading: false, error: action.payload, scheduleNotificationSuccess: false };
    default:
      return state;
  }
};
